import defaultState from "./state";

const asignacionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "MODIFYING_ASIGNAR_ROLES": {
      return Object.assign({}, state, {
        phase: action.phase,
      });
    }
    case "LOADING_ASIGNAR_ROLES": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_ROLES": {
      return Object.assign({}, state, {
        isOpenModalEditarRoles: action.isOpen,
        selectedTrabajador: action.data,
      });
    }
    case "SET_DATA_USER_PORTAL_EMPRESA": {
      return Object.assign({}, state, {
        userPortalEmpresa: action.data,
      });
    }
    case "OPEN_CLOSE_SELECT_ROLES": {
      return Object.assign({}, state, {
        isOpenSelectRoles: action.isOpen,
      });
    }
    case "OPEN_CLOSE_SELECT_GRUPOS": {
      return Object.assign({}, state, {
        isOpenSelectGrupos: action.isOpen,
      });
    }
    case "SET_SELECTED_TRABAJADOR": {
      return Object.assign({}, state, {
        selectedTrabajador: action.newData,
      });
    }
    case "SET_LISTAS_PORTAL_EMPRESA": {
      return Object.assign({}, state, {
        gruposPortalEmpresa: action.grupos,
        rolesPortalEmpresa: action.roles,
      });
    }
    case "SHOW_HIDE_LOADING_RESUME": {
      return Object.assign({}, state, {
        isOpenLoadingResume: action.show,
      });
    }
    case "SET_LOADING_RESUME_DATA": {
      return Object.assign({}, state, {
        loadingResumeData: { ...action.data },
      });
    }
    case "SET_SELECTED_TAB": {
      return Object.assign({}, state, {
        selectedTab: action.tab,
      });
    }
    case "SET_ROLES_TRABAJADOR_FILTER_GESTION": {
      return Object.assign({}, state, {
        rolesTrabajadorFilterGestion: action.filters,
      });
    }
    case "SET_ROLES_EMPRESA_FILTER_GESTION": {
      return Object.assign({}, state, {
        rolesEmpresaFilterGestion: action.filters,
      });
    }
    case "SET_ROLES": {
      // state.rolesAll = state.roles ?? [];
      // action.roles = action.roles ?? [];

      return Object.assign({}, state, {
        // rolesAll: [ //NOTE USE state.mantenedores.roles insetead!!
        //   ...state.rolesAll,
        //   ...action.roles
        // ],
        // roles: [
        //   ...state.roles,
        //   ...action.roles
        // ],
        roles: action.roles
      });
    }
    case "SET_EMPLOYESS": {
      return Object.assign({}, state, {
        employees: action.employees,
      });
    }
    case "SET_ROLES_FILTER": {
      return Object.assign({}, state, {
        rolesFilter: action.filter,
      });
    }
    /**
     * Reducer para guardar la pagina actual de la tabla
     * de Gestión de usuarios en roles
     */
    case "SET_CURRENT_PAGE_USERS": {
      return Object.assign({}, state, {
        currentPage: action.currentPage,
      });
    }
    /**
     * Reducer para guardar la pagina el size de la tabla
     * de Gestión de usuarios en roles
     */
    case "SET_CURRENT_PAGE_SIZE_USERS": {
      return Object.assign({}, state, {
        currentSize: action.pageSize,
      });
    }

    /**
     * Reducer para guardar el texto de la busqueda de la tabla
     * de Gestión de usuarios en roles
     */
    case "SET_SEARCH_USER": {
      return Object.assign({}, state, {
        employeeSearch: action.employeeSearch,
      });
    }
    case "OPEN_CLOSE_MODAL_DEL_ROLES": {
      return Object.assign({}, state, {
        isOpenModalDelRoles: action.isOpen,
        selectedTrabajador: action.data,
      });
    }
    case "DEL_ROLES_TRABAJADOR": {
      return Object.assign({}, state, {
        data: action.data,
      });
    }
    default:
      return state;
  }
};

export default asignacionReducer;
